import { z } from "zod";

/**
 * Adds email confirmation validation to a schema.
 * Requires the schema to have `email` and `confirmEmail` fields.
 *
 * @example
 * const schema = withEmailConfirmation(z.object({
 *   email: emailField,
 *   confirmEmail: confirmEmailField,
 *   firstName: firstNameField,
 *   // ... other fields
 * }));
 */
export const withEmailConfirmation = <
  T extends z.ZodObject<
    z.ZodRawShape & {
      email: z.ZodString;
      confirmEmail: z.ZodString;
    }
  >
>(
  schema: T
): z.ZodEffects<T, z.infer<T>, z.infer<T>> =>
  // An address is the same address however it is capitalised, and a phone
  // keyboard capitalises the first letter of one field and not the other.
  schema.refine(
    (data) =>
      String(data.email).trim().toLowerCase() ===
      String(data.confirmEmail).trim().toLowerCase(),
    {
      message: "Email addresses must match",
      path: ["confirmEmail"],
    }
  );

